export default {"src":"/_next/static/media/GoNoodleLogo_Icon_Reverse.bcc64e35.svg","height":65,"width":87,"blurWidth":0,"blurHeight":0};